import {
    TOKEN_LIST_PAGE_LOADED,
    TOKEN_LIST_PAGE_UNLOADED,
    TOKEN_DETAIL_PAGE_LOADED,
    TOKEN_DETAIL_PAGE_UNLOADED,
    TOKEN_CREATE,
    TOKEN_UPDATE,
    TOKEN_CREATE_PAGE_UNLOADED,
    TOKEN_UPDATE_PAGE_UNLOADED,
    TOKEN_APPROVE,
    TOKEN_REJECT,
    TOKEN_UNPAUSE,
    TOKEN_PAUSE,
    TOKEN_CREATION_FEE_PAGE_LOADED,
    TOKEN_CREATION_FEE_PAGE_UNLOADED,
    TOKEN_CREATION_FEE_UPDATE,
    TOKEN_ADMIN_LIST_PAGE_LOADED,
    TOKEN_ADMIN_LIST_PAGE_UNLOADED,
} from '../constants/actionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case TOKEN_LIST_PAGE_LOADED:
            return {
                ...state,
                tokens: action.payload,
            };

        case TOKEN_DETAIL_PAGE_LOADED:
            return {
                ...state,
                token: action.payload
            };
        case TOKEN_LIST_PAGE_UNLOADED:
        case TOKEN_DETAIL_PAGE_UNLOADED:
        case TOKEN_CREATE_PAGE_UNLOADED:
        case TOKEN_UPDATE_PAGE_UNLOADED:
        case TOKEN_CREATION_FEE_PAGE_UNLOADED:
        case TOKEN_ADMIN_LIST_PAGE_UNLOADED:
            return {};
        case TOKEN_CREATE:
        case TOKEN_UPDATE:
        case TOKEN_APPROVE:
        case TOKEN_REJECT:
        case TOKEN_UNPAUSE:
        case TOKEN_PAUSE:
        case TOKEN_CREATION_FEE_UPDATE:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.error : null,
                codeStatus: action.error
                    ? null
                    : action.payload
                        ? action.payload.code_status
                        : null,
            };
        case TOKEN_CREATION_FEE_PAGE_LOADED:
            return {
                ...state,
                creationFees: action.error ? null : action.payload
            }
        case TOKEN_ADMIN_LIST_PAGE_LOADED:
            return {
                ...state,
                users: action.error ? [] : action.payload
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/token.js